import {
  View,
  Text,
  SafeAreaView,
  TouchableOpacity,
  Keyboard,
  Platform,
} from "react-native";
import React, { useEffect } from "react";
import MyView from "./components/custom/MyView";
import Header from "./components/header/Header";
import MainNavigator from "./screens/bottomNavigator/Main";
import Cookies from "universal-cookie";
import { createDrawerNavigator } from "@react-navigation/drawer";
import HeaderProfileIcon from "./components/header/HeaderProfileIcon";
import MyText from "./components/custom/MyText";
import { primary } from "./colors";
import Wallet from "./components/drawer/Wallet";
import SectionButton from "./components/drawer/SectionButton";
import translate from "./functions/translate";
import PersonIcon from "./assets/svg/PersonIcon";
import SupportIcon from "./assets/svg/SupportIcon";
import InfoIcon from "./assets/svg/InfoIcon";
import LogoutIcon from "./assets/svg/LogoutIcon";
import Dropdown from "./components/custom/Dropdown";
import LoggedIn from "./components/drawer/LoggedIn";
import NotLoggedIn from "./components/drawer/NotLoggedIn";
import { useSelector, useDispatch } from "react-redux";
import LoginModal from "./components/modals/LoginModal";
import { addToken, setRtl } from "./redux/main/mainAction";
import TestStartInfo from "./screens/doTest/TestStartInfo";
import DoTestNavigator from "./screens/doTest/DoTestNavigator";
import { getStringData, storeStringData } from "./functions/db/db";
import userValidInformation from "./api/post/userValidInformation";
import { setUserInformation } from "./redux/user/userAction";
import { useState } from "react";
import { useIsFocused } from "@react-navigation/native";
import Connection from "./screens/main/Connection";
import Splash from "./Splash";
import NoMoneyModal from "./components/modals/NoMoneyModal";
const cookies = new Cookies();
const Drawer = createDrawerNavigator();
export default function Main() {
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const [tempToken, setTempToken] = useState(null);
  const isFocused = useIsFocused();

  useEffect(() => {
    if (main.rtl) {
      dispatch(setRtl());
    }
  }, [main.rtl]);

  useEffect(() => {
    if (main.token === null || main.token !== tempToken) {
      setTempToken(main.token);
      if (main.token !== null) {
        userValidInformation(main.token).then(({ data }) => {
          if (data.status === 200) dispatch(setUserInformation(data.data));
        });
      }
      if (Platform.OS !== "web") {
        getStringData("token")
          .then((data) => {
            if (data === null) {
            } else {
              const myToken = data;
              userValidInformation(data)
                .then(({ data }) => {
                  if (data.status === 200) {
                    dispatch(setUserInformation(data.data));
                    dispatch(addToken(myToken));
                  } else {
                    storeStringData("token", null);
                    dispatch(setUserInformation({}));
                  }
                })
                .catch((error) => {
                  storeStringData("token", null);
                  dispatch(setUserInformation({}));
                });
            }
          })
          .catch((error) => {
            storeStringData("token", null);
            dispatch(setUserInformation({}));
          });
      } else {
        const tok = cookies.get("token");

        if (tok === null) {
        } else {
          const myToken = tok;
          userValidInformation(myToken)
            .then(({ data }) => {
              if (data.status === 200) {
                dispatch(setUserInformation(data.data));
                dispatch(addToken(myToken));
              } else {
                cookies.set("token", null);
                dispatch(setUserInformation({}));
              }
            })
            .catch((error) => {
              cookies.set("token", null);
              dispatch(setUserInformation({}));
            });
        }
      }
    }
  }, [main.token, isFocused]);

  const DrawerContent = () => {
    return main.token === null ? <NotLoggedIn /> : <LoggedIn />;
  };
  return main.token !== null ? (
    <View style={{ flex: 1, backgroundColor: "#fff" }} rtl={main.rtl}>
      <Drawer.Navigator
        initialRouteName="main"
        useLegacyImplementation={false}
        screenOptions={{
          headerShown: false,
          drawerPosition: main.rtl ? "right" : "left",
          drawerStyle: {
            width: 220,
          },
        }}
        drawerContent={(props) => <DrawerContent {...props} />}
      >
        <Drawer.Screen name="main" component={MainNavigator} />
        <Drawer.Screen
          name="DoTest"
          options={{ swipeEnabled: false }}
          component={DoTestNavigator}
        />
      </Drawer.Navigator>
      <LoginModal />
      <NoMoneyModal />
      <Connection />
    </View>
  ) : (
    <View>
      <Splash />
    </View>
  );
}
